(function () {
  'use strict';

  class TextHighlight extends HTMLElement {
    connectedCallback() {
      if (this.dataset.highlightReady === 'true') return;

      const phrases = (this.dataset.highlightPhrases || '')
        .split(',')
        .map((phrase) => phrase.trim())
        .filter(Boolean)
        .sort((first, second) => second.length - first.length);

      if (phrases.length === 0) return;

      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          if (!node.nodeValue.trim() || node.parentElement.closest('.rich-text-highlight__mark')) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        },
      });
      const textNodes = [];

      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((textNode) => this.highlightNode(textNode, phrases));
      this.dataset.highlightReady = 'true';
    }

    highlightNode(textNode, phrases) {
      const source = textNode.nodeValue;
      const fragment = document.createDocumentFragment();
      let cursor = 0;
      let foundMatch = false;

      while (cursor < source.length) {
        let nextMatch = null;

        phrases.forEach((phrase) => {
          const index = source.indexOf(phrase, cursor);
          if (index === -1) return;

          if (!nextMatch || index < nextMatch.index || (index === nextMatch.index && phrase.length > nextMatch.phrase.length)) {
            nextMatch = { index, phrase };
          }
        });

        if (!nextMatch) break;

        foundMatch = true;
        if (nextMatch.index > cursor) fragment.append(source.slice(cursor, nextMatch.index));

        const mark = document.createElement('span');
        mark.className = 'rich-text-highlight__mark';
        mark.textContent = nextMatch.phrase;
        fragment.append(mark);
        cursor = nextMatch.index + nextMatch.phrase.length;
      }

      if (!foundMatch) return;
      if (cursor < source.length) fragment.append(source.slice(cursor));
      textNode.replaceWith(fragment);
    }
  }

  if (!customElements.get('text-highlight')) {
    customElements.define('text-highlight', TextHighlight);
  }
})();
